/**
 * @fileoverview WhatsAppButton.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React from 'react';
import { motion } from 'framer-motion';

function WhatsAppButton() {
  // Direct WhatsApp click-to-chat API using KITH Travels official number
  const whatsappUrl = "https://wa.me/94703272573?text=Hi%20KITH%20Travels,%20I'm%20interested%20in%20planning%20a%20tour%20to%20Sri%20Lanka.";

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[999] md:hidden w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-2xl hover:bg-[#20ba5a] active:scale-95 transition-all duration-200"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: 1, type: "spring", stiffness: 260, damping: 20 }}
      title="Chat with us on WhatsApp"
      id="whatsapp-mobile-btn"
    >
      <svg 
        className="w-7 h-7 fill-current" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.73-1.45L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.625 1.451 5.403.002 9.803-4.381 9.805-9.771.001-2.61-1.01-5.066-2.848-6.905C16.39 2.09 13.938.948 12.008.948c-5.406 0-9.81 4.394-9.814 9.784-.002 1.702.447 3.366 1.301 4.868l-.48 1.753.513-.48 2.062-1.92zm11.758-5.326c-.33-.165-1.951-.963-2.251-1.072-.3-.11-.518-.165-.736.165-.218.33-.845 1.072-1.036 1.29-.19.219-.38.247-.712.082-.33-.165-1.396-.514-2.66-1.64-1.026-.915-1.719-2.046-1.92-2.378-.201-.33-.021-.508.143-.672.148-.148.33-.385.496-.578.165-.192.22-.33.33-.55.11-.22.055-.412-.027-.577-.083-.165-.736-1.774-1.009-2.433-.267-.643-.56-.554-.767-.565-.2-.01-.429-.012-.66-.012-.23 0-.603.085-.92.426-.316.34-1.21 1.182-1.21 2.88 0 1.7 1.236 3.34 1.408 3.57.172.23 2.43 3.71 5.888 5.197.822.354 1.464.566 1.966.724.826.262 1.577.225 2.17.137.662-.1 1.951-.798 2.224-1.53.272-.732.272-1.36.19-1.492-.08-.135-.297-.217-.628-.383z" />
      </svg>
    </motion.a>
  );
}

export default WhatsAppButton;
